import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';


const initScheduleBlockSlider = () => {
    
    const scheduleBlock = Array.from(document.querySelectorAll('.schedule-slider'));

    scheduleBlock.forEach(el => {
        
        if (el.inited) {
            return;
        }

        el.inited = true;

        let swiper;

        if (window.innerWidth > 768) {
            swiper = new Swiper(el, {
                modules: [Navigation],
                slidesPerView: 3.8,
                spaceBetween: 40,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });

            el.swiperInstance = swiper;
        } else if(swiper) {
            swiper.destroy();
        }

        
    });
};

initScheduleBlockSlider();

export default initScheduleBlockSlider;